import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取管理员下拉列表
  getOrgList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/getOrgInfoByUserAccount`, { params });
  },
  // 修改子系统状态
  updateNickName(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysOrg/updateOrgNickName`, params);
  }
}
